module.exports = {
    // clean all of the saved data
    clear: function() {
        window.sessionStorage.clear();
    },
    /**
     * Set an item to the store
     * @param {string} key   the key
     * @param {Object} value the object
     */
    setItem: function(key, value) {
        let s;
        if (value == null || typeof value === 'undefined') {
            s = '';
        } else {
            if (typeof value === 'string') {
                s = value;
            } else {
                s = JSON.stringify(value);
            }
        }
        window.sessionStorage.setItem(key, s);
    },

    /**
     * Get an item from the store
     * @param  {string} key the key
     * @return {Object}     the value. maybe null
     */
    getItem: function(key) {
        const stringVal = window.sessionStorage.getItem(key);
        if (stringVal == null || stringVal.length === 0 ) return null;
        if (stringVal.startsWith('{') || stringVal.startsWith('}')) {
            return JSON.parse(stringVal);
        }

        return stringVal;
    },

    /**
     * Save the app info the the store
     * @param  {Object} appInfo the app info
     * @return {void}         
     */
    saveAppInfo: function(appInfo) {
        this.setItem('_app_info', appInfo);
    },

    /**
     * Get the app info from the store
     * @return {Object} the app info object
     */
    getAppInfo: function() {
        return this.getItem('_app_info');
    },

    saveToken: function(token) {
        this.setItem('_token', token);
    },

    getToken: function() {
        return this.getItem('_token');
    },


};